<template>
  <section :class="$style.panel">
    <slot></slot>
  </section>
</template>

<script lang="ts" setup></script>

<style module lang="scss">
.panel {
  padding: 24px;
  background-color: $color-surface-primary;
  border-radius: $border-radius-v2-rounder;
}
</style>
